// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"d9e5892b","216":"9c917686","341":"8a54a012","496":"8af0e86a","715":"6893e333","787":"60753b13","989":"968db3db","998":"116bd716"}[chunkId] + ".chunk.js";
};